module.exports = __webpack_public_path__ + "img/材料力学1_5_5.f8fd34e8.jpg";